import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'menu-chosen-products',
  styles: [
    `
      .variant-item + .variant-item {
          margin-top: 8px;
      }
    `
  ],
  template: `
    <div class="font-sm mt-2">
      <ng-container *ngFor="let item of menuChosenProducts | keyvalue">
        <div class="variant-item">
          <div class="fw-bold">{{ item.value[0].productTypeName }}:</div>

          <div *ngFor="let variant of item.value">
            {{ variant.count }} x {{ variant.variantName }}
          </div>
        </div>
      </ng-container>
    </div>
  `,
})
export class MenuChosenProductsComponent implements OnInit {
  @Input() menuChosenProducts: Record<number, { count: number, variantName: string, productTypeName: string }[]>;

  constructor() { }

  ngOnInit() {
  }

}
